"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "assertArray", {
  enumerable: true,
  get: function get() {
    return _assertArray["default"];
  }
});
Object.defineProperty(exports, "assertNumber", {
  enumerable: true,
  get: function get() {
    return _assertNumber["default"];
  }
});
Object.defineProperty(exports, "assertObject", {
  enumerable: true,
  get: function get() {
    return _assertObject["default"];
  }
});
Object.defineProperty(exports, "assertShape", {
  enumerable: true,
  get: function get() {
    return _assertShape["default"];
  }
});
Object.defineProperty(exports, "assertString", {
  enumerable: true,
  get: function get() {
    return _assertString["default"];
  }
});
Object.defineProperty(exports, "assertStringOrNumber", {
  enumerable: true,
  get: function get() {
    return _assertStringOrNumber["default"];
  }
});
exports.checkValueExist = checkValueExist;
Object.defineProperty(exports, "createValidity", {
  enumerable: true,
  get: function get() {
    return _createValidity["default"];
  }
});
var _createValidity = _interopRequireDefault(require("./createValidity"));
var _assertArray = _interopRequireDefault(require("./assertArray"));
var _assertNumber = _interopRequireDefault(require("./assertNumber"));
var _assertObject = _interopRequireDefault(require("./assertObject"));
var _assertShape = _interopRequireDefault(require("./assertShape"));
var _assertString = _interopRequireDefault(require("./assertString"));
var _assertStringOrNumber = _interopRequireDefault(require("./assertStringOrNumber"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function checkValueExist(value) {
  return value !== null && value !== undefined;
}


//////////////////
// WEBPACK FOOTER
// ./~/@mhub/web-validations/dist/utils/index.js
// module id = 97
// module chunks = 0